import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.assign.js";
import { __awaiter } from "tslib";
import { mergeProps } from '../../utils/with-default-props';
import { show } from './show';
var defaultProps = {
  confirmText: '确定',
  cancelText: '取消',
  confirmColor: 'primary',
  cancelColor: 'default'
};
export function confirm(p) {
  var _this = this;

  var props = mergeProps(defaultProps, p);
  return new Promise(function (resolve) {
    show(Object.assign(Object.assign({}, props), {
      closeOnAction: true,
      onClose: function onClose() {
        var _a;

        (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
        resolve(false);
      },
      actions: [{
        key: 'cancel',
        text: props.cancelText,
        color: props.cancelColor,
        onClick: function onClick() {
          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var _a;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return (_a = props.onCancel) === null || _a === void 0 ? void 0 : _a.call(props);

                  case 2:
                    resolve(false);

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
        }
      }, {
        key: 'confirm',
        text: props.confirmText,
        color: props.confirmColor,
        onClick: function onClick() {
          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            var _b;

            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return (_b = props.onConfirm) === null || _b === void 0 ? void 0 : _b.call(props);

                  case 2:
                    resolve(true);

                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));
        }
      }]
    }));
  });
}